var render = function render(){var _vm=this,_c=_vm._self._c;return _c('svg',_vm._g({attrs:{"height":"24","width":"24","xmlns":"http://www.w3.org/2000/svg"}},_vm.$listeners),[_c('path',{attrs:{"d":"M20 3a1 1 0 0 1 1 1v16a1 1 0 1 1-2 0V4a1 1 0 0 1 1-1zM7.25 4.519l7.399 5.92a2 2 0 0 1 0 3.123l-7.4 5.92C5.94 20.528 4 19.595 4 17.918V6.081c0-1.677 1.94-2.61 3.25-1.562zM6 6.08v11.838L13.4 12z","fill-rule":"evenodd"}})])
}
var staticRenderFns = []

export { render, staticRenderFns }